export default __webpack_public_path__ + "Logo_Flat3_Color_WhiteText.png?cb9436e12a55c3a35b8283e4075e9ef0";